import * as React from 'react';
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import HotelIcon from '@mui/icons-material/Hotel'
import ChevronRightSharpIcon from '@mui/icons-material/ChevronRightSharp';
import { useHistory } from "react-router";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import { ProvidersAffiliateOrders, USER } from "../../constants/provider/constant"

export default function NestedList(props) {
  const history = useHistory();
  const [open, setOpen] = React.useState(true);
  const providerId = USER && USER.user.providerId;

  const [lists] = React.useState([
    { id: 1, name: 'New Appointments', routeName: '/appointments' },
    { id: 2, name: 'Confirmed Appointments', routeName: '/appointments/confirmed' },
    { id: 3, name: 'Documents Pending', routeName: '/documents/pending' },
    { id: 4, name: 'Documents Submitted', routeName: '/documents/received' },
    { id: 5, name: 'Settled', routeName: '/cases/settled' },
    { id: 6, name: 'Cancelled', routeName: '/cases/cancelled' },
  ]);


  const routesTo = (routeName) => {
    history.push("/" + localStorage.getItem("roleName") + routeName);
    props.toggleDrawerFunction()
  }

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <List
      sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        props.providerDetails && props.providerDetails.fullName ?
          <ListSubheader component="div" className="p-0" id="nested-list-subheader" sx={{ padding: 0 }}>
            <div className='font-semibold bg-nested-menu-header leading-tight pt-4 pb-6 px-4'>
              <div>
                {props.providerDetails.fullName}
              </div>
            </div>
          </ListSubheader> : ''
      }
    >
      <ListItemButton onClick={handleClick}>
        <ListItemIcon sx={{ minWidth: '40px' }}>
          <HotelIcon />
        </ListItemIcon>
        <ListItemText primary="Appointments" />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {
            lists ? lists.map((elem, index) => (
              <ListItemButton key={index} sx={{ pl: 3 }} onClick={() => routesTo(elem.routeName)}>
                <ListItemIcon sx={{ minWidth: '30px' }}>
                  <ChevronRightSharpIcon />
                </ListItemIcon>
                <span className="text-sm">
                  {elem.name}
                </span>
              </ListItemButton>
            )) : <></>
          }
        </List>
      </Collapse>
      {
        ProvidersAffiliateOrders.includes(providerId) &&
        <ListItemButton onClick={() => routesTo('/create/order')}>
          <ListItemIcon sx={{ minWidth: '40px' }}>
            <AddCircleRoundedIcon />
          </ListItemIcon>
          <ListItemText primary="Create Order" />
        </ListItemButton>
      }

    </List>
  );
}